/**
 * This module is a central location from which BSA events should be emitted.
 * It usually reacts to events emitted by other components.
 */
import $ = require('jquery');

//FIXME: this should be organized better, as a class with invididual methods, or multiple functions
export const attachEvents = () => {
    // file manager events
    $(document).bind('diy-editor-filemanager-opened', () => {
        $(document.body).trigger('ImagePoolOpened.BSA');
    });
    $(document).bind('diy-editor-filemanager-uploadedFiles', () => {
        $(document.body).trigger('ImagePoolUsed.BSA');
    });
    $(document).bind('diy-editor-filemanager-createdFolder', () => {
        $(document.body).trigger('ImagePoolUsed.BSA');
    });
    $(document).bind('diy-editor-filemanager-newSearch', () => {
        $(document.body).trigger('ImagePoolUsed.BSA');
    });
};

export const trigger = (eventName: string, payload?: any) => {
    $(document.body).trigger(eventName, payload);
};



/** WEBPACK FOOTER **
 ** ./build/js/~/tslint-loader!./source/cdn/document_root/s/diy/bsa-events/bsaEvents.ts
 **/